"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isTransportError(error) {
    return error !== undefined && error.transport !== undefined;
}
exports.default = isTransportError;
//# sourceMappingURL=is-transport-error.js.map